'use client'

import React from 'react'

import { UnderlineBase } from './styles'

export interface UnderlineProps {
  /**
   * Class name
   */
  className?: string

  /**
   * Underline text
   */
  children: React.ReactNode
}

export const Underline = ({ className, children }: UnderlineProps) => {
  return <UnderlineBase className={className}>{children}</UnderlineBase>
}
